import * as entities from 'redux-modules/entity'
import * as activities from './activity'
import * as adCampaigns from './adCampaign'
import * as adminDashboard from './adminDashboard'
import * as agencies from './agency'
import * as agencyDashboard from '../../../agency/redux/modules/agencyDashboard'
import * as agencyDigitalTemplates from './agencyDigitalTemplate'
import * as agencyOrderBundles from './agencyOrderBundle'
import * as agencyPortals from './agencyPortal'
import * as agencyProviderDeadlineGroups from './agencyProviderDeadlineGroup'
import * as agencyProviderPackages from './agencyProviderPackage'
import * as agencyProviderPriceOverrides from './agencyProviderPriceOverride'
import * as agencyProviders from './agencyProvider'
import * as agencyPublications from './agencyPublication'
import * as agencyTemplatePages from './agencyTemplatePage'
import * as agents from './agent'
import * as apiKeys from './apiKey'
import * as apiLogs from './apiLog'
import * as appOrderPrices from './appOrderPrices'
import * as artworkComments from './artworkComment'
import * as artworkPageItems from './artworkPageItem'
import * as artworkPages from './artworkPage'
import * as artworkReviews from './artworkReview'
import * as artworks from './artwork'
import * as assetLibraries from './assetLibrary'
import * as attachments from './attachment'
import * as bookings from './booking'
import * as brandColours from './brandColour'
import * as brandGroupMembers from './brandGroupMember'
import * as brandGroupPaginations from './brandGroupPagination'
import * as brandGroupProviders from './brandGroupProvider'
import * as brandGroupPublications from './brandGroupPublication'
import * as brandGroups from './brandGroup'
import * as brandThemeTemplatePages from './brandThemeTemplatePage'
import * as brandThemes from './brandTheme'
import * as brandhub from './brandhub'
import * as brands from './brand'
import * as campaignCategories from './campaignCategory'
import * as campaignCommercialCategories from './campaignCommercialCategory'
import * as campaignPortalSyncs from './campaignPortalSync'
import * as campaignQuoteTemplates from './campaignQuoteTemplate'
import * as campaignRuralCategories from './campaignRuralCategory'
import * as campaignSaleMethods from './campaignSaleMethod'
import * as campaignStatuses from './campaignStatus'
import * as campaignTypes from './campaignType'
import * as campaigns from './campaign'
import * as charts from './charts'
import * as comments from './comment'
import * as contracts from './contract'
import * as conversations from './conversation'
import * as couriers from './courier'
import * as currentUser from './currentUser'
import * as customDeadlines from './customDeadline'
import * as customShortcodes from './customShortcode'
import * as deadlines from './deadline'
import * as digitalComponents from './digitalComponent'
import * as digitalTemplateBuilder from './digitalTemplateBuilder'
import * as digitalTemplatePages from './digitalTemplatePage'
import * as digitalTemplates from './digitalTemplate'
import * as directoryListingTypes from './directoryListingType'
import * as directoryListings from './directoryListing'
import * as favouriteOrders from './favouriteOrder'
import * as fontFamilies from './fontFamily'
import * as fonts from './font'
import * as forms from './forms'
import * as geoCountries from './geoCountry'
import * as geoStates from './geoState'
import * as geoSuburbs from './geoSuburb'
import * as helpDesk from './helpDesk'
import * as imageLibraries from './imageLibrary'
import * as images from './image'
import * as integrations from './integration'
import * as invoiceItems from './invoiceItem'
import * as invoices from './invoice'
import * as layoutTemplates from './layoutTemplate'
import * as loginSessions from './loginSession'
import * as micrositeTemplates from './micrositeTemplate'
import * as notifications from './notification'
import * as orderBundleItems from './orderBundleItem'
import * as orderBundles from './orderBundle'
import * as orderItemTaskTypes from './orderItemTaskType'
import * as orderItemTasks from './orderItemTask'
import * as orderItems from './orderItem'
import * as orderLeadTimes from './orderLeadTime'
import * as orderTrackingCodes from './orderTrackingCode'
import * as orders from './order'
import * as paginationRules from './paginationRule'
import * as paymentMethods from './paymentMethod'
import * as portalOptionValues from './portalOptionValue'
import * as portalOptions from './portalOption'
import * as portals from './portal'
import * as priceLists from './priceList'
import * as pricingPlans from './pricingPlan'
import * as processingFees from './processingFee'
import * as providerAccounts from './providerAccount'
import * as providerDashboard from './providerDashboard'
import * as providerDeadlineGroups from './providerDeadlineGroup'
import * as providerDisclaimers from './providerDisclaimer'
import * as providerOrderCodes from './providerOrderCode'
import * as providerPackageItems from './providerPackageItem'
import * as providerPackages from './providerPackage'
import * as providerPriceListItemOptions from './providerPriceListItemOption'
import * as providerPriceListItems from './providerPriceListItem'
import * as providerPriceListProductUnlocks from './providerPriceListProductUnlock'
import * as providerPriceLists from './providerPriceList'
import * as providerProductCodes from './providerProductCode'
import * as providerServices from './providerService'
import * as providerTemplatePages from './providerTemplatePage'
import * as providerZones from './providerZone'
import * as providers from './provider'
import * as publicationBookingItems from './publicationBookingItem'
import * as publicationBookings from './publicationBooking'
import * as publicationCompatiblePaginations from './publicationCompatiblePagination'
import * as publicationEditions from './publicationEdition'
import * as publicationInspections from './publicationInspection'
import * as publicationOptionValues from './publicationOptionValue'
import * as publicationOptions from './publicationOption'
import * as publicationOrders from './publicationOrder'
import * as publicationPackageProducts from './publicationPackageProduct'
import * as publicationPackagePublications from './publicationPackagePublication'
import * as publicationPackageRules from './publicationPackageRule'
import * as publicationPackages from './publicationPackage'
import * as publicationPaginationRules from './publicationPaginationRule'
import * as publicationProducts from './publicationProduct'
import * as publicationSpecialDeadlines from './publicationSpecialDeadline'
import * as publicationTemplatePages from './publicationTemplatePage'
import * as publications from './publication'
import * as reports from './reports'
import * as roles from './role'
import * as serviceCategories from './serviceCategory'
import * as serviceProductTemplatePages from './serviceProductTemplatePage'
import * as serviceProducts from './serviceProduct'
import * as services from './service'
import * as settings from './settings'
import * as smsLogs from './smsLog'
import * as statuses from './status'
import * as systemManager from './systemManager'
import * as systems from './system'
import * as tags from './tag'
import * as taskLists from './taskList'
import * as templateBuilder from './templateBuilder'
import * as templatePageAttachments from './templatePageAttachment'
import * as templatePageCategories from './templatePageCategory'
import * as templatePageItems from './templatePageItem'
import * as templatePagePartials from './templatePagePartial'
import * as templatePages from './templatePage'
import * as trainingCourses from './trainingCourse'
import * as trainingDashboard from './trainingDashboard'
import * as trainingLessons from './trainingLesson'
import * as trainingModules from './trainingModule'
import * as trainingSessions from './trainingSession'
import * as users from './user'
import * as webhooks from './webhook'

const modules = {
  activities,
  adCampaigns,
  adminDashboard,
  agencies,
  agencyDashboard,
  agencyDigitalTemplates,
  agencyOrderBundles,
  agencyPortals,
  agencyProviderDeadlineGroups,
  agencyProviderPackages,
  agencyProviderPriceOverrides,
  agencyProviders,
  agencyPublications,
  agencyTemplatePages,
  agents,
  apiKeys,
  apiLogs,
  appOrderPrices,
  // artworkBuilder,
  artworkComments,
  artworkPageItems,
  artworkPages,
  artworkReviews,
  artworks,
  assetLibraries,
  attachments,
  bookings,
  brandColours,
  brandGroupMembers,
  brandGroupPaginations,
  brandGroupProviders,
  brandGroupPublications,
  brandGroups,
  brandThemeTemplatePages,
  brandThemes,
  brandhub,
  brands,
  campaignCategories,
  campaignCommercialCategories,
  campaignPortalSyncs,
  campaignQuoteTemplates,
  campaignRuralCategories,
  campaignSaleMethods,
  campaignStatuses,
  campaignTypes,
  campaigns,
  charts,
  comments,
  contracts,
  conversations,
  couriers,
  currentUser,
  customDeadlines,
  customShortcodes,
  deadlines,
  digitalComponents,
  digitalTemplateBuilder,
  digitalTemplatePages,
  digitalTemplates,
  directoryListingTypes,
  directoryListings,
  entities,
  favouriteOrders,
  fontFamilies,
  fonts,
  forms,
  geoCountries,
  geoStates,
  geoSuburbs,
  helpDesk,
  imageLibraries,
  images,
  integrations,
  invoiceItems,
  invoices,
  layoutTemplates,
  loginSessions,
  micrositeTemplates,
  notifications,
  orderBundleItems,
  orderBundles,
  orderItemTaskTypes,
  orderItemTasks,
  orderItems,
  orderLeadTimes,
  orderTrackingCodes,
  orders,
  paginationRules,
  paymentMethods,
  portalOptionValues,
  portalOptions,
  portals,
  priceLists,
  pricingPlans,
  processingFees,
  providerAccounts,
  providerDashboard,
  providerDeadlineGroups,
  providerDisclaimers,
  providerOrderCodes,
  providerPackageItems,
  providerPackages,
  providerPriceListItemOptions,
  providerPriceListItems,
  providerPriceListProductUnlocks,
  providerPriceLists,
  providerProductCodes,
  providerServices,
  providerTemplatePages,
  providerZones,
  providers,
  publicationBookingItems,
  publicationBookings,
  publicationCompatiblePaginations,
  publicationEditions,
  publicationInspections,
  publicationOptionValues,
  publicationOptions,
  publicationOrders,
  publicationPackageProducts,
  publicationPackagePublications,
  publicationPackageRules,
  publicationPackages,
  publicationPaginationRules,
  publicationProducts,
  publicationSpecialDeadlines,
  publicationTemplatePages,
  publications,
  reports,
  roles,
  serviceCategories,
  serviceProductTemplatePages,
  serviceProducts,
  services,
  settings,
  smsLogs,
  statuses,
  systemManager,
  systems,
  tags,
  taskLists,
  templateBuilder,
  templatePageAttachments,
  templatePageCategories,
  templatePageItems,
  templatePagePartials,
  templatePages,
  trainingCourses,
  trainingDashboard,
  trainingLessons,
  trainingModules,
  trainingSessions,
  users,
  webhooks,
}

const keys = Object.keys(modules)
export const reducers = keys.reduce((acc, moduleKey) => {
  const module = modules[moduleKey]
  acc[moduleKey] = module.default

  return acc
}, {})

export default modules
